export default "__VITE_ASSET__C0iRXVn3__"